<template>
  <div class="e-feedback-template e-scroll-container">
    <VuePerfectScrollbar class="e-content__inner">
      <div class="e-content__scroll">
        <div class="e-module e-module--limited e-module--left">
          <Loading v-if="loading" />

          <template v-else>
            <header class="e-module__head">
              <h1 v-if="sent">
                {{ $t('system.feedback.submit.successHead') }}
              </h1>
              <h1 v-else>
                {{ $t('system.navigation.feedback') }}
              </h1>
            </header>
            <div class="e-module__body">
              <div v-if="sent" v-html="$t('system.feedback.submit.success')" />

              <template v-else>
                <div class="e-feedback__entrytext" v-html="entryText" />

                <!-- Errormessages -->
                <el-alert
                  v-for="(item, index) in errors.messages"
                  :key="index"
                  :title="$t(index)"
                  type="error"
                  v-html="$t(item)"
                />
                <!-- /Errormessages -->

                <el-form
                  ref="feedbackForm"
                  :model="formData"
                  :rules="rules"
                  class="e-feedback"
                  label-position="top"
                >
                  <el-form-item
                    label="Bezieht sich deine Meinung auf die Mail- oder die Chat-Beratung? Bitte wähle aus:"
                    prop="contact"
                    :required="true"
                  >
                    <el-radio
                      v-model="formData.contact"
                      label="email"
                      aria-labelledby="feedback-email-label"
                    >
                      <span id="feedback-email-label">Mail-Beratung</span>
                    </el-radio>

                    <el-radio
                      v-model="formData.contact"
                      label="chat"
                      aria-labelledby="feedback-chat-label"
                    >
                      <span id="feedback-chat-label">Chat-Beratung</span>
                    </el-radio>
                  </el-form-item>

                  <el-form-item
                    v-for="item in formFields"
                    :key="item.uuid"
                    :prop="item.uuid"
                    :label="item.question"
                    :required="item.mandatory"
                  >
                    <el-input
                      v-if="item.freetext"
                      v-model="formData[item.uuid]"
                      autosize
                      type="textarea"
                      :id="item.uuid"
                    />

                    <FeedbackItem
                      v-else
                      :mandatory="item.mandatory"
                      :item-key="item.uuid"
                      @select="storeFeedback"
                    />
                  </el-form-item>

                  <div class="e-form__row e-form__row--submit">
                    <div />
                    <el-button
                      :loading="sending"
                      type="primary"
                      @click.prevent="submitForm('feedbackForm')"
                    >
                      {{ $t('system.feedback.send') }}
                    </el-button>
                  </div>
                </el-form>
              </template>
            </div>
          </template>
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import api from 'api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Loading from 'atoms/Loading/Loading'
import FeedbackItem from 'molecules/FeedbackItem/FeedbackItem'

export default {
  components: {
    VuePerfectScrollbar,
    Loading,
    FeedbackItem
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    formFields: {
      type: Array,
      default: () => []
    },
    entryText: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    sending: false,
    sent: false,
    errors: {},
    formData: {
      contact: null
    }
  }),

  computed: {
    rules() {
      const rules = {}
      rules['contact'] = [
        {
          required: true,
          message: this.$t('system.feedback.pleaseAnswerThisQuestion')
        }
      ]
      for (const item of this.formFields) {
        if (item.mandatory) {
          rules[item.uuid] = [
            {
              required: true,
              message: this.$t('system.feedback.pleaseAnswerThisQuestion')
            }
          ]
        }
      }
      return rules
    }
  },
  methods: {
    storeFeedback(data) {
      this.formData = { ...this.formData, [data.key]: data.choice }
    },

    submitForm(formName) {
      this.errors.messages = []
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sendForm()
        } else {
          this.errors.status = 400
          this.errors.messages = ['system.feedback.pleaseAnswerAllQuestions']
          this.$forceUpdate()
        }
      })
    },

    async sendForm() {
      this.sending = true
      this.sent = false

      try {
        const data = Object.assign({}, this.formData)
        await api.call('sendFeedback', null, data)

        this.sent = true
      } catch (error) {
        this.$error(error)
        if (error.messages) {
          this.errors = error
        }
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_assets/feedback';
</style>
